






















import Vue from "vue";

import { PRIVATE_ROUTE_NAMES, EXERCISES_ROUTE_NAMES } from "@tt-app/router";
import {
  VUEX_USER_NAMESPACE,
  VUEX_USER_ACTION_NAMES,
  VUEX_ROOT_ACTION_NAMES
} from "@tt-app/constants";
import { refreshAudioContext } from "@tt-app/utils/audio/audioContext";

import LayoutPrivate from "@tt-app/layouts/LayoutPrivate.vue";
import LayoutPublic from "@tt-app/layouts/LayoutPublic.vue";
import MaintenanceMode from "@tt-app/views/MaintenanceMode.vue";
import NotificationToast from "@tt-app/components/exercise/common/NotificationToast.vue";
import ReloadRequiredAlert from "@tt-app/components/layout/ReloadRequiredAlert.vue";
import TerratalkLiveSessionOwnerAlert from "@tt-app/components/layout/TerratalkLiveSessionOwnerAlert.vue";
import TerratalkLiveSessionEndedAlert from "@tt-app/components/layout/TerratalkLiveSessionEndedAlert.vue";
import TerratalkLiveLimitedModeStartedAlert from "@tt-app/components/layout/TerratalkLiveLimitedModeStartedAlert.vue";

const { LOAD_LOCAL_STORAGE_DATA_REQUEST } = VUEX_USER_ACTION_NAMES;

const {
  DETERMINE_ANDROID_APP_VERSION,
  DETERMINE_IOS_APP_VERSION,
  MANAGE_DEVICE_UUID,
  ONE_SIGNAL_GET_NOTIFICATION_PERMISSION
} = VUEX_ROOT_ACTION_NAMES;

interface Data {
  terratalkLivePollingInterval: any;
}

interface Methods {
  setNotificationPermissionStatus: () => void;
  visibilityStateWatcher: () => void;
}

interface Computed {
  courseUuid: string;
  exerciseUuid: string;
  layoutName: string | undefined;
  maintenanceMode: boolean;
  routeKey: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "TerratalkApp",
  components: {
    LayoutPublic,
    LayoutPrivate,
    MaintenanceMode,
    NotificationToast,
    ReloadRequiredAlert,
    TerratalkLiveLimitedModeStartedAlert,
    TerratalkLiveSessionOwnerAlert,
    TerratalkLiveSessionEndedAlert
  },
  created() {
    this.$store.dispatch(MANAGE_DEVICE_UUID);
    this.$store.dispatch(DETERMINE_ANDROID_APP_VERSION);
    this.$store.dispatch(DETERMINE_IOS_APP_VERSION);

    this.$store.dispatch(`${VUEX_USER_NAMESPACE}/${LOAD_LOCAL_STORAGE_DATA_REQUEST}`);
    this.$store.dispatch(ONE_SIGNAL_GET_NOTIFICATION_PERMISSION);
    this.$OneSignal.on("notificationPermissionChange", this.setNotificationPermissionStatus);

    document.addEventListener("visibilitychange", this.visibilityStateWatcher);

    (window as any).iOSAppEvents = {
      onAppDidEnterForeground: this.setNotificationPermissionStatus,
      onAppDidEnterBackground: () => {
        console.log("app entered background");
      }
    };
  },
  beforeDestroy() {
    this.$OneSignal.off("notificationPermissionChange", this.setNotificationPermissionStatus);
  },
  data() {
    return {
      terratalkLivePollingInterval: undefined
    };
  },
  methods: {
    setNotificationPermissionStatus() {
      this.$store.dispatch(ONE_SIGNAL_GET_NOTIFICATION_PERMISSION);
    },

    visibilityStateWatcher() {
      if (document.visibilityState === "visible") {
        refreshAudioContext();
      }
    }
  },
  computed: {
    courseUuid() {
      return this.$route.params.courseUuid;
    },
    exerciseUuid() {
      return this.$route.params.exerciseUuid;
    },
    layoutName() {
      const routeName = this.$route.name;

      // Exercise does not need a global layout as each page is somehow
      // exercise-specific
      if (routeName && EXERCISES_ROUTE_NAMES.includes(routeName)) {
        return undefined;
      } else if (routeName && PRIVATE_ROUTE_NAMES.includes(routeName)) {
        return "layout-private";
      }

      return "layout-public";
    },
    maintenanceMode() {
      return this.$store.state.maintenanceMode.active;
    },
    routeKey() {
      return `${this.courseUuid}-${this.exerciseUuid}`;
    }
  }
});
